import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { ProductDetailsService } from '../../../services/product.service'

@Component({
    selector: 'app-environmental-info-tab',
    templateUrl: './environmental-info-tab.component.html',
    styleUrls: ['./environmental-info-tab.component.scss'],
    standalone: false
})
export class EnvironmentalInfoTabComponent implements OnInit {
  public environmentalInfo: string
  product$: Observable<any>

  constructor(private productDetailsService: ProductDetailsService) {}

  ngOnInit(): void {
    this.product$ = this.productDetailsService.getProductDetail$().pipe(
      tap((currentProduct: ICustomProduct) => {
        if (currentProduct && currentProduct.environmentalInfo) {
          this.environmentalInfo = currentProduct.environmentalInfo
        } else {
          this.environmentalInfo = null
        }
      })
    )
  }
}
